<template>
  <div v-if="!closed && visible" :class="{callout: true, [`callout--${kind}`]: true, 'callout--rounded': rounded}">
    <div class="callout__body">
      <slot/>
    </div>
    <button v-if="dismissible" type="button" class="callout__close" aria-label="Dismiss" @click.prevent.stop="onCloseRequest">
      <svg aria-hidden="true" focusable="false" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Callout',
  emits: ['close'],
  props: {
    kind: {
      type: String,
      default: 'default',
      validate(value) {
        return ['primary', 'danger', 'info', 'warning'].includes(value);
      },
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      closed: false,
    };
  },
  methods: {
    onCloseRequest() {
      this.closed = true;
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.callout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  gap: 1rem;

  &--rounded {
    border-radius: .25rem;
  }

  &__body {
    color: #fff;
  }

  &--default {
    background: #F0EEE7;
    border-color: #E7E4DA;

    .callout__body {
      color: #15171C;
    }
  }

  &--info {
    background: #cffafe;
    border-color: rgba(8, 145, 178, 0.3);

    /* WCAG 1.4.3: was #0891b2 (~3.29:1 on #cffafe, fails 4.5:1). #0c5460
       clears AA against this background. */
    .callout__body { color: #0c5460; }
  }

  &--warning {
    background: #fff8e1;
    border-color: #f6c90e;

    .callout__body { color: #7a5c00; }
  }

  &--primary {
    background: #fff8e1;
    border-color: #f6c90e;

    .callout__body { color: #7a5c00; }
  }

  &--danger {
    background: #f8d7da;
    border-color: rgba(220, 53, 69, 0.3);

    .callout__body { color: #dc3545; }
  }

  &__body {
    font-weight: 500;
  }

  &__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    min-width: 1.25rem;
    max-width: 1.25rem;
    height: 1.25rem;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.18);
    padding: 3px;
    color: rgba(0, 0, 0, 0.55);
    font: inherit;
    line-height: 0;
    transition: background 0.15s, color 0.15s;

    &:hover {
      background: rgba(0, 0, 0, 0.15);
      color: #000;
    }

    &:focus-visible {
      outline: 2px solid currentColor;
      outline-offset: 2px;
    }
  }
}
</style>
